import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";

var bem = function bem(block, element, modifiers, additionalClasses) {
  if (block === void 0) {
    block = '';
  }

  if (element === void 0) {
    element = '';
  }

  if (modifiers === void 0) {
    modifiers = [];
  }

  if (additionalClasses === void 0) {
    additionalClasses = [];
  }

  var base = block && element ? block + '__' + element : [block, element].join('');
  var componentClasses = (base + " " + modifiers.map(function (mod) {
    return base + "--" + mod;
  }).join(' ')).trim();

  if (additionalClasses.length) {
    return componentClasses + ' ' + additionalClasses.join(' ');
  }

  return componentClasses;
};

export default bem;